import { Filter, Sort, SortDirectionS3 } from "./filters";

export class PageStateData {
    search: string = '';
    page: number = 0;
    filter: Filter = Filter.None;
    sort: Sort = Sort.None;
    sortDirection: SortDirectionS3 = SortDirectionS3.None;
}